import * as React from 'react';
var initial = {
  visible: false,
  index: -1,
  itemsRefs: [],
  referenceElement: null,
  dispatch: function dispatch() {}
};

// $FlowFixMe[incompatible-call]
export default /*#__PURE__*/React.createContext(initial);